import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { getCorridorData } from '../loadCorridorData';

export const load = (async (event) => {
	const { itineraryResultsStore, searchParams } = await event.parent();

	const { poisStore, corridorPolygonStore } = await getCorridorData({
		event,
		searchParams,
		itineraryResultsStore,
	});

	return {
		poisStore,
		pagename: routesPagename.ROUTE_ON_THE_WAY_FILTER,
		corridorPolygonStore,
	};
}) satisfies PageLoad;
